import moment from "moment";
import axiosConfig from "../../../config/axiosConfig";
import {
  GET_IN_REPAIR_INVENTORIES_URL,
  GET_INVENTORY_SINGLE_ROW_URL,
  GET_INVENTORIES_COUNTRY_NAME_TOTAL_QTY_GRAPH_URL,
  GET_INVENTORIES_PART_TYPE_TOTAL_QTY_GARPH_URL,
  GET_INVENTORIES_RR_URL,
  GET_INVENTORY_FILTER_URL,
  GET_INVENTORY_LATEST_UPDATE_URL,
  GET_INVENTORY_PART_CLASS_TOTAL_QTY_GRAPH_URL,
  GET_INVENTORY_STOCK_SUMMARY_DETAILS_URL,
  GET_INVENTORY_TEARDOWN_LIST_URL,
  GET_INVENTORY_TIER_GRAPH_COUNT_GRAPH_URL,
  GET_INVENTORY_URL,
  GET_RO_INVENTORIES_SINGLE_ROW_URL,
  GET_RO_INVENTORIES_URL,
  GET_REPAIR_ORDER_RAG_DETAIL_URL,
  GET_REPAIR_ORDER_RAG_LISTING_URL,
  GET_REPAIR_ORDER_RAG_PRIORITY_VIEW_LISTING_URL,
  GET_REPAIR_ORDER_RAG_PRIORITY_VIEW_SUMMARY_URL,
  GET_REPAIR_ORDER_RVE_SNAPSHOT_CHART_URL,
  GET_REPAIR_ORDER_RVE_SNAPSHOT_LISTING_URL,
  GET_REPAIR_ORDER_RVE_SNAPSHOT_SUMMARY_URL,
  GET_REPAIR_ORDER_VENDOR_SCORECARD_GRAPH_URL,
  GET_REPAIR_ORDER_VENDOR_SCORECARD_LISTING_URL,
  GET_REPAIR_ORDER_VENDOR_SCORECARD_RAG_GRAPH_URL,
  GET_REPAIR_ORDER_ANALYTICS_DELAY_ATTRIBUTION_GRAPH_URL,
  GET_REPAIR_ORDER_ANALYTICS_PHASE_VOLUME_GRAPH_URL,
  GET_REPAIR_ORDER_ANALYTICS_PRIORITY_TIER_GRAPH_URL,
  GET_REPAIR_ORDER_ANALYTICS_RAG_DISTRIBUTION_GRAPH_URL,
  GET_REPAIR_ORDER_ANALYTICS_WORKSTREAM_SPLIT_GRAPH_URL,
  GET_REPAIR_ORDER_DATA_QUALITY_LISTING_URL,
  GET_REPAIR_ORDER_DATA_QUALITY_SUMMARY_URL,
  GET_REPAIR_ORDER_RAG_SUMMARY_URL,
  SLOW_MOVEING_INVENTORIES_SINGLE_ROW_URL,
  SLOW_MOVEING_INVENTORIES_URL,
  UNDER_STOCK_INVENTORIES_SINGLE_ROW_URL,
  UNDER_STOCK_INVENTORIES_URL,
} from "../../../config/config";
import { createQueryParams, getStringFromArray } from "../../../utils/helper";
import { resolveInventoryDynamicFilters } from "../../../utils/inventoryDynamicFilters";

const toMultiSelectParam = (value) => {
  if (Array.isArray(value)) {
    return getStringFromArray(value) || undefined;
  }
  return value;
};

export const GetInventoriesService = (params) => {
  const {
    page,
    per_page,
    qty_available,
    tier,
    from_date,
    to_date,
    status,
    ata_chapter,
    serial_number,
    pn_type,
    pn,
    order_by,
    description,
    // stm_unit_cost,
    rec_date,
    stock_visible,
    dynamic_cat,
    full_dynamic_cat,
    application_code,
    fair_market_value,
    fmv,
    recommended_for_repair,
    condition_code,
    part_tier,
    sc_group,
    part_class_description,
    hide_historic,
    single_row_view,
  } = params;

  const paramsList = {
    page,
    per_page,
    from_date: from_date,
    to_date: to_date,
    tier: tier,
    qty_available: qty_available,
    status: status,
    ata_chapter,
    serial_number,
    pn_type: pn_type,
    pn,
    order_by,
    description,
    // stm_unit_cost,
    rec_date,
    stock_visible,
    dynamic_cat,
    full_dynamic_cat,
    application_code,
    fair_market_value,
    part_tier,
    fmv,
    dynamic_filters: resolveInventoryDynamicFilters(params),
    recommended_for_repair: recommended_for_repair?.value,
    condition_code,
    sc_group,
    part_class_description,
    hide_historic,
  };
  const queryString = createQueryParams(paramsList);
  const baseUrl = single_row_view ? GET_INVENTORY_SINGLE_ROW_URL : GET_INVENTORY_URL;
  const url = `${baseUrl}${queryString ? `?${queryString}` : ""}`;
  return axiosConfig.get(url);
};

export const GetInventoriesFilterService = (params) => {
  const { filed } = params;
  return axiosConfig.get(`${GET_INVENTORY_FILTER_URL}?filter_key=${filed}`);
};

export const GetInRepairInventoriesService = (params) => {
  const {
    page,
    per_page,
    manufacturer,
    qty_available,
    tier,
    part_tier,
    from_date,
    to_date,
    status,
    ata_chapter,
    serial_number,
    pn_type,
    order_by,
    pn,
    stock_line,
    application_code,
    fair_market_value,
    // stm_unit_cost,
    msn_esn,
    repair_type,
    repair_vendors,
    condition_code,
    description,
    ro_number,
    rec_date,
    ro_entry_date,
    stock_visible,
    full_dynamic_cat,
    dynamic_cat,
    sc_group,
    part_class_description,
    received_by,
    expected_delivery_date,
    ro_quote_date,
    ro_quote_approved_date,
    shipped_to_vendor_date,
  } = params;

  // Prepare the parameters for the query string (InRepair version)
  const paramsList = {
    page,
    per_page,
    from_date: from_date,
    to_date: to_date,
    tier: tier,
    part_tier,
    qty_available: qty_available,
    pnm_auto_key__manufacturer: manufacturer,
    status: status,
    pn_type: pn_type,
    ata_chapter,
    serial_number,
    order_by,
    pn,
    stock_line,
    application_code,
    fair_market_value,
    // stm_unit_cost,
    msn_esn,
    repair_type,
    repair_vendors,
    condition_code,
    description,
    ro_number,
    rec_date,
    ro_entry_date,
    stock_visible,
    full_dynamic_cat,
    dynamic_cat,
    sc_group,
    part_class_description,
    dynamic_filters: resolveInventoryDynamicFilters(params),
    received_by,
    expected_delivery_date,
    ro_quote_date,
    ro_quote_approved_date,
    shipped_to_vendor_date,
  };

  // Create the query string for the 'InRepair' inventories
  const queryString = createQueryParams(paramsList);
  const url = `${GET_IN_REPAIR_INVENTORIES_URL}${queryString ? `?${queryString}` : ""}`;

  return axiosConfig.get(url);
};

export const GetROInventoriesService = (params) => {
  const {
    page,
    per_page,
    manufacturer,
    qty_available,
    tier,
    part_tier,
    from_date,
    to_date,
    status,
    ata_chapter,
    serial_number,
    pn_type,
    order_by,
    pn,
    stock_line,
    application_code,
    fair_market_value,
    // stm_unit_cost,
    msn_esn,
    repair_type,
    repair_vendors,
    condition_code,
    description,
    ro_number,
    rec_date,
    ro_entry_date,
    stock_visible,
    full_dynamic_cat,
    dynamic_cat,
    sc_group,
    part_class_description,
    received_by,
    expected_delivery_date,
    ro_quote_date,
    ro_quote_approved_date,
    shipped_to_vendor_date,
    airframe_rve,
    engine_rve,
    ro_status,
    ro_workscope,
    single_row_view,
  } = params;

  // Prepare the parameters for the query string (InRepair version)
  const paramsList = {
    page,
    per_page,
    from_date: from_date,
    to_date: to_date,
    tier: tier,
    part_tier,
    qty_available: qty_available,
    pnm_auto_key__manufacturer: manufacturer,
    status: status,
    pn_type: pn_type,
    ata_chapter,
    serial_number,
    order_by,
    pn,
    stock_line,
    application_code,
    fair_market_value,
    // stm_unit_cost,
    msn_esn,
    repair_type,
    repair_vendors,
    condition_code,
    description,
    ro_number,
    rec_date,
    ro_entry_date,
    stock_visible,
    full_dynamic_cat,
    dynamic_cat,
    sc_group,
    part_class_description,
    dynamic_filters: resolveInventoryDynamicFilters(params),
    received_by,
    expected_delivery_date,
    ro_quote_date,
    ro_quote_approved_date,
    shipped_to_vendor_date,
    airframe_rve,
    engine_rve,
    ro_status,
    ro_workscope,
  };

  // Create the query string for the 'InRepair' inventories
  const queryString = createQueryParams(paramsList);
  const baseUrl = single_row_view
    ? GET_RO_INVENTORIES_SINGLE_ROW_URL
    : GET_RO_INVENTORIES_URL;
  const url = `${baseUrl}${queryString ? `?${queryString}` : ""}`;

  return axiosConfig.get(url);
};

export const GetRepairOrderRAGListingService = (params) => {
  const {
    page,
    per_page,
    group_by,
    rve,
    vendor,
    stage,
    priority_tier,
    workstream,
    sc_group,
    search,
    rag_status,
    order_by,
    subrow,
    parent_sc_group,
    parent_rve,
    parent_vendor,
    parent_priority_tier,
    parent_ro_number,
  } = params;

  const paramsList = {
    page,
    per_page,
    group_by,
    rve,
    vendor,
    stage,
    priority_tier,
    workstream,
    sc_group,
    search,
    rag_status,
    order_by,
    subrow,
    parent_sc_group,
    parent_rve,
    parent_vendor,
    parent_priority_tier,
    parent_ro_number,
  };

  const queryString = createQueryParams(paramsList);
  const url = `${GET_REPAIR_ORDER_RAG_LISTING_URL}${queryString ? `?${queryString}` : ""}`;

  return axiosConfig.get(url);
};

export const GetRepairOrderRAGDetailService = (params) => {
  const { id } = params;
  const queryString = createQueryParams({ id });
  const url = `${GET_REPAIR_ORDER_RAG_DETAIL_URL}${queryString ? `?${queryString}` : ""}`;

  return axiosConfig.get(url);
};

export const GetRepairOrderRAGSummaryService = (params) => {
  const {
    rve,
    vendor,
    stage,
    priority_tier,
    workstream,
    sc_group,
    search,
  } = params;

  const paramsList = {
    rve,
    vendor,
    stage,
    priority_tier,
    workstream,
    sc_group,
    search,
  };

  const queryString = createQueryParams(paramsList);
  const url = `${GET_REPAIR_ORDER_RAG_SUMMARY_URL}${queryString ? `?${queryString}` : ""}`;

  return axiosConfig.get(url);
};

export const GetRepairOrderRAGPriorityViewListingService = (params) => {
  const {
    page,
    per_page,
    rve,
    vendor,
    stage,
    priority_tier,
    ro_number,
    commercial_workstream,
    rag_status,
    sc_group,
    search,
    order_by,
    dynamic_filters,
  } = params;

  const paramsList = {
    page,
    per_page,
    rve: toMultiSelectParam(rve),
    vendor: toMultiSelectParam(vendor),
    stage,
    priority_tier: toMultiSelectParam(priority_tier),
    ro_number,
    commercial_workstream: toMultiSelectParam(commercial_workstream),
    rag_status: toMultiSelectParam(rag_status),
    sc_group: toMultiSelectParam(sc_group),
    search,
    order_by,
    dynamic_filters,
  };

  const queryString = createQueryParams(paramsList);
  const url = `${GET_REPAIR_ORDER_RAG_PRIORITY_VIEW_LISTING_URL}${queryString ? `?${queryString}` : ""}`;

  return axiosConfig.get(url);
};

export const GetRepairOrderRAGPriorityViewSummaryService = (params) => {
  const {
    rve,
    vendor,
    stage,
    priority_tier,
    ro_number,
    workstream,
    commercial_workstream,
    rag_status,
    sc_group,
    search,
    dynamic_filters,
  } = params;

  const paramsList = {
    rve: toMultiSelectParam(rve),
    vendor: toMultiSelectParam(vendor),
    stage,
    priority_tier: toMultiSelectParam(priority_tier),
    ro_number,
    commercial_workstream: toMultiSelectParam(commercial_workstream),
    rag_status: toMultiSelectParam(rag_status),
    sc_group: toMultiSelectParam(sc_group),
    search,
    dynamic_filters,
  };

  const queryString = createQueryParams(paramsList);
  const url = `${GET_REPAIR_ORDER_RAG_PRIORITY_VIEW_SUMMARY_URL}${queryString ? `?${queryString}` : ""}`;

  return axiosConfig.get(url);
};

export const GetRepairOrderRveSnapshotSummaryService = () => {
  return axiosConfig.get(GET_REPAIR_ORDER_RVE_SNAPSHOT_SUMMARY_URL);
};

export const GetRepairOrderRveSnapshotListingService = (params) => {
  const { page, per_page, order_by } = params;

  const paramsList = {
    page,
    per_page,
    order_by,
  };

  const queryString = createQueryParams(paramsList);
  const url = `${GET_REPAIR_ORDER_RVE_SNAPSHOT_LISTING_URL}${queryString ? `?${queryString}` : ""}`;

  return axiosConfig.get(url);
};

export const GetRepairOrderRveSnapshotChartService = () => {
  return axiosConfig.get(GET_REPAIR_ORDER_RVE_SNAPSHOT_CHART_URL);
};

export const GetRepairOrderVendorScorecardListingService = (params) => {
  const { page, per_page, order_by, vendor, risk_flag } = params;

  const paramsList = {
    page,
    per_page,
    order_by,
    vendor,
    risk_flag,
  };

  const queryString = createQueryParams(paramsList);
  const url = `${GET_REPAIR_ORDER_VENDOR_SCORECARD_LISTING_URL}${queryString ? `?${queryString}` : ""}`;

  return axiosConfig.get(url);
};

export const GetRepairOrderVendorScorecardGraphService = (params) => {
  const { vendor, risk_flag } = params ?? {};

  const paramsList = {
    vendor,
    risk_flag,
  };

  const queryString = createQueryParams(paramsList);
  const url = `${GET_REPAIR_ORDER_VENDOR_SCORECARD_GRAPH_URL}${queryString ? `?${queryString}` : ""}`;

  return axiosConfig.get(url);
};

export const GetRepairOrderVendorScorecardRagGraphService = (params) => {
  const { vendor, risk_flag } = params ?? {};

  const paramsList = {
    vendor,
    risk_flag,
  };

  const queryString = createQueryParams(paramsList);
  const url = `${GET_REPAIR_ORDER_VENDOR_SCORECARD_RAG_GRAPH_URL}${queryString ? `?${queryString}` : ""}`;

  return axiosConfig.get(url);
};

export const GetRepairOrderAnalyticsPriorityTierGraphService = (params = {}) => {
  const {
    sc_group,
    vendor,
    rve_owner,
    commercial_workstream,
    rag_status,
    phase,
  } = params;

  const paramsList = {
    sc_group: toMultiSelectParam(sc_group),
    vendor: toMultiSelectParam(vendor),
    rve_owner: toMultiSelectParam(rve_owner),
    commercial_workstream: toMultiSelectParam(commercial_workstream),
    rag_status: toMultiSelectParam(rag_status),
    phase: toMultiSelectParam(phase),
  };

  const queryString = createQueryParams(paramsList);
  const url = `${GET_REPAIR_ORDER_ANALYTICS_PRIORITY_TIER_GRAPH_URL}${queryString ? `?${queryString}` : ""}`;
  return axiosConfig.get(url);
};

export const GetRepairOrderAnalyticsWorkstreamSplitGraphService = (params = {}) => {
  const {
    sc_group,
    vendor,
    rve_owner,
    priority_tier,
    rag_status,
    phase,
  } = params;

  const paramsList = {
    sc_group: toMultiSelectParam(sc_group),
    vendor: toMultiSelectParam(vendor),
    rve_owner: toMultiSelectParam(rve_owner),
    priority_tier: toMultiSelectParam(priority_tier),
    rag_status: toMultiSelectParam(rag_status),
    phase: toMultiSelectParam(phase),
  };

  const queryString = createQueryParams(paramsList);
  const url = `${GET_REPAIR_ORDER_ANALYTICS_WORKSTREAM_SPLIT_GRAPH_URL}${queryString ? `?${queryString}` : ""}`;
  return axiosConfig.get(url);
};

export const GetRepairOrderAnalyticsRagDistributionGraphService = (params = {}) => {
  const {
    sc_group,
    vendor,
    rve_owner,
    commercial_workstream,
    priority_tier,
    phase,
  } = params;

  const paramsList = {
    sc_group: toMultiSelectParam(sc_group),
    vendor: toMultiSelectParam(vendor),
    rve_owner: toMultiSelectParam(rve_owner),
    commercial_workstream: toMultiSelectParam(commercial_workstream),
    priority_tier: toMultiSelectParam(priority_tier),
    phase: toMultiSelectParam(phase),
  };

  const queryString = createQueryParams(paramsList);
  const url = `${GET_REPAIR_ORDER_ANALYTICS_RAG_DISTRIBUTION_GRAPH_URL}${queryString ? `?${queryString}` : ""}`;
  return axiosConfig.get(url);
};

export const GetRepairOrderAnalyticsPhaseVolumeGraphService = (params = {}) => {
  const {
    sc_group,
    vendor,
    rve_owner,
    commercial_workstream,
    rag_status,
    priority_tier,
  } = params;

  const paramsList = {
    sc_group: toMultiSelectParam(sc_group),
    vendor: toMultiSelectParam(vendor),
    rve_owner: toMultiSelectParam(rve_owner),
    commercial_workstream: toMultiSelectParam(commercial_workstream),
    rag_status: toMultiSelectParam(rag_status),
    priority_tier: toMultiSelectParam(priority_tier),
  };

  const queryString = createQueryParams(paramsList);
  const url = `${GET_REPAIR_ORDER_ANALYTICS_PHASE_VOLUME_GRAPH_URL}${queryString ? `?${queryString}` : ""}`;
  return axiosConfig.get(url);
};

export const GetRepairOrderAnalyticsDelayAttributionGraphService = (params = {}) => {
  const {
    sc_group,
    vendor,
    rve_owner,
    commercial_workstream,
    priority_tier,
  } = params;

  const paramsList = {
    sc_group: toMultiSelectParam(sc_group),
    vendor: toMultiSelectParam(vendor),
    rve_owner: toMultiSelectParam(rve_owner),
    commercial_workstream: toMultiSelectParam(commercial_workstream),
    priority_tier: toMultiSelectParam(priority_tier),
  };

  const queryString = createQueryParams(paramsList);
  const url = `${GET_REPAIR_ORDER_ANALYTICS_DELAY_ATTRIBUTION_GRAPH_URL}${queryString ? `?${queryString}` : ""}`;
  return axiosConfig.get(url);
};

export const GetRepairOrderDataQualitySummaryService = (params) => {
  const {
    rve_owner,
    vendor,
    commercial_workstream,
    ro_number,
    issue_type,
    severity,
  } = params ?? {};

  const paramsList = {
    rve_owner: toMultiSelectParam(rve_owner),
    vendor: toMultiSelectParam(vendor),
    commercial_workstream: toMultiSelectParam(commercial_workstream),
    ro_number,
    issue_type,
    severity,
  };
  const queryString = createQueryParams(paramsList);
  const url = `${GET_REPAIR_ORDER_DATA_QUALITY_SUMMARY_URL}${queryString ? `?${queryString}` : ""}`;

  return axiosConfig.get(url);
};

export const GetRepairOrderDataQualityListingService = (params) => {
  const {
    page,
    per_page,
    order_by,
    rve_owner,
    vendor,
    commercial_workstream,
    ro_number,
    issue_type,
    severity,
  } = params;

  const paramsList = {
    page,
    per_page,
    order_by,
    rve_owner: toMultiSelectParam(rve_owner),
    vendor: toMultiSelectParam(vendor),
    commercial_workstream: toMultiSelectParam(commercial_workstream),
    ro_number,
    issue_type,
    severity,
  };

  const queryString = createQueryParams(paramsList);
  const url = `${GET_REPAIR_ORDER_DATA_QUALITY_LISTING_URL}${queryString ? `?${queryString}` : ""}`;

  return axiosConfig.get(url);
};

export const GetUnderStockInventoriesService = (params) => {
  const {
    page,
    per_page,
    manufacturer,
    qty_available,
    tier,
    part_tier,
    status,
    ata_chapter,
    serial_number,
    pn_type,
    order_by,
    under_stock_threshold,
    application_code,
    part_number,
    fair_market_value,
    qty_reserved,
    qty_sold,
    qty_oh,
    rec_date,
    pn,
    region,
    description,
    full_dynamic_cat,
    dynamic_cat,
    sc_group,
    part_class_description,
    hide_historic,
    condition_code,
    qty_exceed,
    single_row_view,
  } = params;

  // Prepare the parameters for the query string (InRepair version)
  const paramsList = {
    page,
    per_page,
    tier: tier,
    serial_number,
    qty_available: qty_available,
    pnm_auto_key__manufacturer: manufacturer,
    status: status,
    pn_type: pn_type,
    ata_chapter,
    order_by,
    under_stock_threshold,
    application_code,
    part_number,
    fair_market_value,
    qty_reserved,
    part_tier,
    qty_sold,
    qty_oh,
    rec_date,
    pn,
    region,
    description,
    full_dynamic_cat,
    dynamic_cat,
    sc_group,
    part_class_description,
    dynamic_filters: resolveInventoryDynamicFilters(params),
    hide_historic,
    condition_code,
    qty_exceed: qty_exceed?.value,
  };

  // Create the query string for the 'InRepair' inventories
  const queryString = createQueryParams(paramsList);
  const baseUrl = single_row_view
    ? UNDER_STOCK_INVENTORIES_SINGLE_ROW_URL
    : UNDER_STOCK_INVENTORIES_URL;
  const url = `${baseUrl}${queryString ? `?${queryString}` : ""}`;

  return axiosConfig.get(url);
};

export const GetSlowMoveingInventoriesService = (params) => {
  const {
    page,
    per_page,
    manufacturer,
    qty_available,
    tier,
    part_tier,
    from_date,
    to_date,
    status,
    ata_chapter,
    serial_number,
    pn_type,
    order_by,
    under_stock_threshold,
    application_code,
    part_number,
    fair_market_value,
    // stm_unit_cost,
    qty_reserved,
    qty_sold,
    qty_oh,
    rec_date,
    stock_visible,
    description,
    pn,
    full_dynamic_cat,
    dynamic_cat,
    sc_group,
    part_class_description,
    single_row_view,
  } = params;
  // Prepare the parameters for the query string (InRepair version)
  const paramsList = {
    page,
    per_page,
    manufacturer,
    qty_available,
    tier,
    from_date: from_date,
    to_date: to_date,
    status,
    ata_chapter,
    serial_number,
    pn_type,
    order_by,
    under_stock_threshold,
    application_code,
    part_number,
    fair_market_value,
    qty_reserved,
    part_tier,
    qty_sold,
    qty_oh,
    rec_date,
    // stm_unit_cost,
    stock_visible,
    description,
    pn,
    full_dynamic_cat,
    dynamic_cat,
    sc_group,
    part_class_description,
    dynamic_filters: resolveInventoryDynamicFilters(params),
  };

  // Create the query string for the 'InRepair' inventories
  const queryString = createQueryParams(paramsList);
  const baseUrl = single_row_view
    ? SLOW_MOVEING_INVENTORIES_SINGLE_ROW_URL
    : SLOW_MOVEING_INVENTORIES_URL;
  const url = `${baseUrl}${queryString ? `?${queryString}` : ""}`;

  return axiosConfig.get(url);
};

export const GetInventoryStockSummaryDetailsService = (params) => {
  const { page, per_page, from_date, to_date, pnm_auto_key, type } = params;
  // filter_key: tier,qty_available,pnm_auto_key__manufacturer
  const paramsList = {
    page,
    per_page,
    from_date: from_date
      ? from_date
      : moment().subtract(18, "years").format("YYYY-MM-DD"),
    to_date: to_date ? to_date : moment().format("YYYY-MM-DD"),
    pnm_auto_key: pnm_auto_key,
    type: type,
  };
  const queryString = createQueryParams(paramsList);
  const url = `${GET_INVENTORY_STOCK_SUMMARY_DETAILS_URL}${queryString ? `?${queryString}` : ""}`;
  return axiosConfig.get(url);
};

export const GetInventoryTeardownService = (params) => {
  const {
    page,
    per_page,
    pnm_auto_key,
    type,
    qty_available,
    manufacturer,
    status,
    pn_type,
    ata_chapter,
    serial_number,
    order_by,
    msn_esn,
    fmv,
    category,
    engine_family,
    engine_type,
    aircraft_family,
    aircraft_type,
    part_number,
    project_asset__msn_esn,
    description,
    tier,
    part_tier,
    quantity,
    full_dynamic_cat,
    dynamic_cat,
    application_code,
    fair_market_value,
    sc_group,
    part_class_description,
    project_id,
  } = params;

  const paramsList = {
    page,
    per_page,
    pnm_auto_key: pnm_auto_key,
    type: type,
    qty_available: qty_available,
    pnm_auto_key__manufacturer: manufacturer,
    status: status,
    pn_type: pn_type,
    ata_chapter,
    serial_number,
    order_by,
    msn_esn,
    part_tier,
    fmv,
    category,
    engine_type,
    engine_family,
    aircraft_family,
    aircraft_type,
    part_number,
    project_asset__msn_esn,
    description,
    tier,
    quantity,
    full_dynamic_cat,
    dynamic_cat,
    application_code,
    fair_market_value,
    sc_group,
    part_class_description,
    project_id,
    dynamic_filters: resolveInventoryDynamicFilters(params),
  };
  const queryString = createQueryParams(paramsList);
  const url = `${GET_INVENTORY_TEARDOWN_LIST_URL}${queryString ? `?${queryString}` : ""}`;
  return axiosConfig.get(url);
};

export const GetInventoryCountryNameTotalQtyGraphService = (data) => {
  return axiosConfig.get(
    GET_INVENTORIES_COUNTRY_NAME_TOTAL_QTY_GRAPH_URL,
    data
  );
};

export const GetInventoryPartClassTotalQtyGraphService = (data) => {
  return axiosConfig.get(GET_INVENTORY_PART_CLASS_TOTAL_QTY_GRAPH_URL, data);
};

export const GetInventoryTierGraphCountGraphService = (data) => {
  return axiosConfig.get(GET_INVENTORY_TIER_GRAPH_COUNT_GRAPH_URL, data);
};

export const GetInventoryPartTypeTotalQtyGraphService = (data) => {
  return axiosConfig.get(GET_INVENTORIES_PART_TYPE_TOTAL_QTY_GARPH_URL, data);
};

export const GetInventorySubrowsService = (params) => {
  const {
    qty_available,
    from_date,
    to_date,
    status,
    serial_number,
    order_by,
    stock_visible,
    application_code,
    condition_code,
    subrow,
    parent_pn,
    parent_status,
    tier,
    ata_chapter,
    pn_type,
    pn,
    description,
    rec_date,
    dynamic_cat,
    full_dynamic_cat,
    fair_market_value,
    fmv,
    recommended_for_repair,
    part_tier,
    sc_group,
    part_class_description,
    hide_historic,
  } = params;

  const paramsList = {
    from_date: from_date,
    to_date: to_date,
    qty_available: qty_available,
    status: status,
    serial_number,
    order_by,
    stock_visible,
    application_code,
    condition_code,
    subrow,
    parent_pn,
    parent_status,
    tier: tier,
    ata_chapter,
    pn_type: pn_type,
    pn,
    description,
    rec_date,
    dynamic_cat,
    full_dynamic_cat,
    fair_market_value,
    part_tier,
    fmv,
    dynamic_filters: resolveInventoryDynamicFilters(params),
    recommended_for_repair: recommended_for_repair?.value,
    sc_group,
    part_class_description,
    hide_historic,
  };
  const queryString = createQueryParams(paramsList);
  const url = `${GET_INVENTORY_URL}${queryString ? `?${queryString}` : ""}`;
  return axiosConfig.get(url);
};

export const GetUnderStockInventorySubrowsService = (params) => {
  const {
    page,
    per_page,
    qty_available,
    status,
    serial_number,
    order_by,
    application_code,
    qty_reserved,
    qty_oh,
    subrow,
    parent_pn,
    parent_status,
    condition_code,
    manufacturer,
    tier,
    part_tier,
    ata_chapter,
    pn_type,
    under_stock_threshold,
    part_number,
    fair_market_value,
    qty_sold,
    rec_date,
    pn,
    region,
    description,
    full_dynamic_cat,
    dynamic_cat,
    sc_group,
    part_class_description,
    hide_historic,
    qty_exceed,
  } = params;

  // Prepare the parameters for the query string (InRepair version)
  const paramsList = {
    page,
    per_page,
    serial_number,
    qty_available: qty_available,
    status: status,
    order_by,
    application_code,
    qty_reserved: qty_reserved,
    qty_oh,
    subrow,
    parent_pn,
    parent_status,
    condition_code,
    tier: tier,
    pnm_auto_key__manufacturer: manufacturer,
    pn_type: pn_type,
    ata_chapter,
    under_stock_threshold,
    part_number,
    fair_market_value,
    part_tier,
    qty_sold,
    rec_date,
    pn,
    region,
    description,
    full_dynamic_cat,
    dynamic_cat,
    sc_group,
    part_class_description,
    dynamic_filters: resolveInventoryDynamicFilters(params),
    hide_historic,
    qty_exceed: qty_exceed?.value,
  };

  // Create the query string for the 'InRepair' inventories
  const queryString = createQueryParams(paramsList);
  const url = `${UNDER_STOCK_INVENTORIES_URL}${queryString ? `?${queryString}` : ""}`;

  return axiosConfig.get(url);
};

export const GetInRepairInventorySubrowsService = (params) => {
  const {
    page,
    per_page,
    qty_available,
    from_date,
    to_date,
    status,
    serial_number,
    order_by,
    stock_line,
    application_code,
    msn_esn,
    condition_code,
    stock_visible,
    subrow,
    parent_pn,
    parent_status,
    manufacturer,
    tier,
    part_tier,
    ata_chapter,
    pn_type,
    pn,
    fair_market_value,
    repair_type,
    repair_vendors,
    description,
    ro_number,
    rec_date,
    ro_entry_date,
    full_dynamic_cat,
    dynamic_cat,
    sc_group,
    part_class_description,
  } = params;

  // Prepare the parameters for the query string (InRepair version)
  const paramsList = {
    page,
    per_page,
    from_date: from_date,
    to_date: to_date,
    qty_available: qty_available,
    status: status,
    serial_number,
    order_by,
    stock_line,
    application_code,
    msn_esn,
    condition_code,
    stock_visible,
    subrow,
    parent_pn,
    parent_status,
    tier: tier,
    part_tier,
    pnm_auto_key__manufacturer: manufacturer,
    pn_type: pn_type,
    ata_chapter,
    pn,
    fair_market_value,
    // stm_unit_cost,
    repair_type,
    repair_vendors,
    description,
    ro_number,
    rec_date,
    ro_entry_date,
    full_dynamic_cat,
    dynamic_cat,
    sc_group,
    part_class_description,
    dynamic_filters: resolveInventoryDynamicFilters(params),
  };

  // Create the query string for the 'InRepair' inventories
  const queryString = createQueryParams(paramsList);
  const url = `${GET_IN_REPAIR_INVENTORIES_URL}${queryString ? `?${queryString}` : ""}`;

  return axiosConfig.get(url);
};

export const GetROInventorySubrowsService = (params) => {
  const {
    page,
    per_page,
    qty_available,
    from_date,
    to_date,
    status,
    serial_number,
    order_by,
    stock_line,
    application_code,
    msn_esn,
    condition_code,
    stock_visible,
    subrow,
    parent_ro,
    parent_status,
    pn,
    manufacturer,
    tier,
    part_tier,
    ata_chapter,
    pn_type,
    fair_market_value,
    // stm_unit_cost,
    repair_type,
    repair_vendors,
    description,
    ro_number,
    rec_date,
    ro_entry_date,
    full_dynamic_cat,
    dynamic_cat,
    sc_group,
    part_class_description,
    received_by,
    expected_delivery_date,
    ro_quote_date,
    ro_quote_approved_date,
    shipped_to_vendor_date,
    airframe_rve,
    engine_rve,
    ro_status,
    ro_workscope,
  } = params;

  // Prepare the parameters for the query string (InRepair version)
  const paramsList = {
    page,
    per_page,
    from_date: from_date,
    to_date: to_date,
    qty_available: qty_available,
    status: status,
    serial_number,
    order_by,
    stock_line,
    application_code,
    msn_esn,
    condition_code,
    stock_visible,
    subrow,
    parent_ro,
    parent_status,
    pn,
    tier: tier,
    part_tier,
    pnm_auto_key__manufacturer: manufacturer,
    pn_type: pn_type,
    ata_chapter,
    fair_market_value,
    // stm_unit_cost,
    repair_type,
    repair_vendors,
    description,
    ro_number,
    rec_date,
    ro_entry_date,
    full_dynamic_cat,
    dynamic_cat,
    sc_group,
    part_class_description,
    dynamic_filters: resolveInventoryDynamicFilters(params),
    received_by,
    expected_delivery_date,
    ro_quote_date,
    ro_quote_approved_date,
    shipped_to_vendor_date,
    airframe_rve,
    engine_rve,
    ro_status,
    ro_workscope,
  };

  // Create the query string for the 'InRepair' inventories
  const queryString = createQueryParams(paramsList);
  const url = `${GET_RO_INVENTORIES_URL}${queryString ? `?${queryString}` : ""}`;

  return axiosConfig.get(url);
};

export const GetSlowMoveingInventorySubrowsService = (params) => {
  const {
    page,
    per_page,
    qty_available,
    from_date,
    to_date,
    status,
    serial_number,
    order_by,
    application_code,
    qty_reserved,
    qty_oh,
    stock_visible,
    subrow,
    parent_pn,
    parent_status,
    manufacturer,
    tier,
    part_tier,
    ata_chapter,
    pn_type,
    under_stock_threshold,
    part_number,
    fair_market_value,
    // stm_unit_cost,
    qty_sold,
    rec_date,
    description,
    pn,
    full_dynamic_cat,
    dynamic_cat,
    sc_group,
    part_class_description,
  } = params;
  // Prepare the parameters for the query string (InRepair version)
  const paramsList = {
    page,
    per_page,
    qty_available,
    from_date: from_date,
    to_date: to_date,
    status,
    serial_number,
    order_by,
    application_code,
    qty_reserved,
    qty_oh,
    stock_visible,
    subrow,
    parent_pn,
    parent_status,
    manufacturer,
    tier,
    ata_chapter,
    pn_type,
    under_stock_threshold,
    part_number,
    fair_market_value,
    part_tier,
    qty_sold,
    rec_date,
    // stm_unit_cost,
    description,
    pn,
    full_dynamic_cat,
    dynamic_cat,
    sc_group,
    part_class_description,
    dynamic_filters: resolveInventoryDynamicFilters(params),
  };

  // Create the query string for the 'InRepair' inventories
  const queryString = createQueryParams(paramsList);
  const url = `${SLOW_MOVEING_INVENTORIES_URL}${queryString ? `?${queryString}` : ""}`;

  return axiosConfig.get(url);
};

export const GetInventoriesRRService = (params) => {
  const {
    page,
    per_page,
    qty_available,
    from_date,
    to_date,
    pn,
    order_by,
    rec_date,
    dynamic_cat,
    fair_market_value,
    fmv,
    condition_code,
    part_class_description,
    lot_consignment_code,
    recommended_repair_qty,
  } = params;

  const paramsList = {
    page,
    per_page,
    from_date: from_date,
    to_date: to_date,
    qty_available: qty_available,
    pn,
    order_by,
    rec_date,
    dynamic_cat,
    fair_market_value,
    fmv,
    dynamic_filters: resolveInventoryDynamicFilters(params),
    condition_code,
    part_class_description,
    lot_consignment_code,
    recommended_repair_qty,
  };
  const queryString = createQueryParams(paramsList);
  const url = `${GET_INVENTORIES_RR_URL}${queryString ? `?${queryString}` : ""}`;
  return axiosConfig.get(url);
};

export const GetINVUpdateTimeService = (params) => {
  const {
   module
  } = params;
  const paramsList = {
    module,
  };
  const queryString = createQueryParams(paramsList);
  const url = `${GET_INVENTORY_LATEST_UPDATE_URL}${queryString ? `?${queryString}` : ""}`;

  return axiosConfig.get(url);
};